exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img_preview{width:100px}.custom-pdf{font-size:100px}", ""]);

// exports
